// dbext:profile=staging_mcdo2019_be
import $ from "jquery";

import admin_general from "./905-admin_general.js";
import admin_crud    from "./910-admin_crud.js";

export default {

    async init()
    {
        // not the admin jobs page? ⇒ do nothing
        if ( $('.js-admin-jobs' ).length == 0 ){
            return;
        }

        // add McDonald's breadcrumb
        admin_general.bread_crumb_add_mcdonalds_link();

        $('.c-cvwarehouse__refresh').on( 'click', this.on__cvwarehouse__click() );

        await this.show_cvwarehouse_cache_timestamp();
    },

    on__cvwarehouse__click()
    {
        return async ( e ) => {

            e.preventDefault();

            // start spinning
            $('.c-cvwarehouse__refresh'  ).addClass('u-disabled');
            $('.js-admin-jobs .c-spinner').addClass('is-spinning');

            let success = await this.refresh_cvwarehouse();

            // stop spinning
            $('.c-cvwarehouse__refresh'  ).removeClass('u-disabled');
            $('.js-admin-jobs .c-spinner').removeClass('is-spinning');

            if ( success ){
                $('.js-admin-jobs .js-refresh-status--ok').show();
                $('.js-admin-jobs .js-refresh-status--ok').fadeOut( 500 );
            }
            else {
                $('.js-admin-jobs .js-refresh-status--error').show();
                $('.js-admin-jobs .js-refresh-status--error').fadeOut( 500 );
            }

            await this.show_cvwarehouse_cache_timestamp();
        };
    },

    async refresh_cvwarehouse()
    {
        let result =  await
        admin_crud.GET( '/en/admin/jobs?api=true&cvwarehouse-refresh=true' );

        // status
        if ( result.status != 200 ){
            return false;
        }
        if ( result.data.status != 'ok' ){
            return false;
        }

        return true;
    },

    async show_cvwarehouse_cache_timestamp()
    {
        $('.js-cvwarehouse-cache-timestamp').text('');

        let result =  await
        admin_crud.GET( '/en/admin/jobs?api=true&cvwarehouse-cache-timestamp=true' );

        // status
        if ( result.status != 200 ){
            return false;
        }
        if ( result.data.status != 'ok' ){
            return false;
        }

        if ( ! result.data.cvwarehouse_cache_timestamp ){
            return false;
        }

        $('.js-cvwarehouse-cache-timestamp').text( 'Cache timestamp: ' + result.data.cvwarehouse_cache_timestamp );
    },

}

